import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-address-kind',
	templateUrl: './address-kind.component.html',
	styleUrls: ['./address-kind.component.css'],
})
export class AddressKindComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/address_kind/';
	protected parentComponent = 'codebook/address_kind';
	parentLocationSet = [];
	protected itemsBeforeDataLoad = 2;
	codebook;

	protected pageTitleGenerate(): string {
		return `Słowniki -> ${this.codebook.name} -> ${this.data.kind} (ID: ${this.data.id})`;
	}

	data = {
		id: null,
		kind: null,
	};

	protected loadBefore(): void {
		this.bag.get('/address_kind', (result, error) => {
			this.parentLocationSet = result.results;
			this.loadData();
		});

		this.bag.get('/codebook/12/', (result, error) => {
			this.codebook = result;
			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected getApiUrl(): string {
		return '/address_kind/' + this.data.id + '/';
	}
}
